import { DNSRecord, SrvDNSRecord } from "../../api/partner/models/DNSZone";

export const RecordNameInput = ({ value, domain, onChange, readonlyMode }: { value: DNSRecord, domain: string, onChange: (record: Partial<DNSRecord>) => void, readonlyMode: boolean }) => {
  switch (value.type) {
    case "SRV":
      return <SrvRecordNameInput readonlyMode={readonlyMode} value={value} onChange={(content) => onChange(content)} domain={domain} />
    default:
      return <BasicRecordNameInput domain={domain} readonlyMode={readonlyMode} value={value.name} onChange={name => onChange({ name })} />
  }
}

const BasicRecordNameInput = ({ value, domain, onChange, readonlyMode }: { value: string, domain: string, onChange: (name: string) => void, readonlyMode: boolean }) => {
  return <label className={`h-full font-mono tracking-tighter flex items-stretch border border-transparent hover:bg-slate-50 rounded-sm focus-within:border-brand-500`}>
    <input type="text" className={"px-2 flex-1 w-auto outline-hidden bg-transparent"} value={excludeDomainName(value, domain)} readOnly={readonlyMode} onChange={e => onChange(includeDomainName(e.target.value, domain))} />
    <div className={"flex items-center mr-2 whitespace-nowrap text-slate-500"}>
      {excludeDomainName(value, domain) === "" ? <>&nbsp;</> : "."}{domain}
    </div>
  </label>
}

const SrvRecordNameInput = ({ value, domain, onChange, readonlyMode }: { value: SrvDNSRecord, domain: string, onChange: (record: Partial<DNSRecord>) => void, readonlyMode: boolean }) => {
  return <div className={"flex flex-col h-20 space-y-1"}>
    <div className={"flex h-full"}>
      <label className={"h-full flex-1 flex items-stretch border border-transparent rounded-sm hover:bg-slate-50 rounded-sm focus-within:border-brand-500"}>
        <span className={"text-sm font-medium text-slate-500 uppercase flex items-center px-2"}>SERVICE: </span>
        {readonlyMode ? <span className={"px-2 flex-1 w-full outline-hidden bg-transparent flex items-center"}>{value.service}</span> : <>
          <input className={'pr-2 flex-1 font-mono tracking-tighter w-full outline-hidden bg-transparent'} placeholder={'...'} type="text" value={value.service} onChange={e => onChange({ service: e.target.value })} />
        </>}
      </label>
      <label className={"h-full flex-1 flex items-stretch border border-transparent rounded-sm hover:bg-slate-50 rounded-sm focus-within:border-brand-500"}>
        <span className={"text-sm font-medium text-slate-500 uppercase flex items-center px-2"}>PROTO: </span>
        {readonlyMode ? <span className={"px-2 flex-1 w-full outline-hidden bg-transparent flex items-center"}>{value.proto}</span> : <>
          <input className={'pr-2 flex-1 font-mono tracking-tighter w-full outline-hidden bg-transparent'} placeholder={'...'} type="text" value={value.proto} onChange={e => onChange({ proto: e.target.value })} />
        </>}
      </label>
    </div>
    <div className={"flex h-full"}>
      <label className={`h-full font-mono tracking-tighter flex items-stretch border border-transparent hover:bg-slate-50 rounded-sm focus-within:border-brand-500`}>
        <input type="text" className={"px-2 flex-1 w-auto outline-hidden bg-transparent"} value={excludeDomainName(value.name, domain)} readOnly={readonlyMode} onChange={e => onChange({ name: includeDomainName(e.target.value, domain) })} />
        <div className={"flex items-center mr-2 whitespace-nowrap text-slate-500"}>
          {excludeDomainName(value.name, domain) === "" ? <>&nbsp;</> : "."}{domain}
        </div>
      </label>
    </div>
  </div>
}

function excludeDomainName(name: string, domain: string) {
  return name.replace("." + domain, "").replace(domain, "")
}
function includeDomainName(name: string, domain: string) {
  if (name === "") {
    return domain
  }
  return `${name}.${domain}`
}
